import { Model } from "flexlayout-react";
import { TableView } from "../tableview/TableView";
import { Controls } from "../controls/Controls";
import { Header } from "../../../components/Header";

export const factory = (node,modelDate) => {
  var component = node.getComponent();
  switch (component) {
    case "TableView":
      return <TableView />;
    case "Controls":
      return <Controls />;
    case "Header":
      return (
        <Header title="Using the Vector Model’s price probabilities we calculate fair value estimates for out of the money strikes scaled in terms of the closing price for the model date indicated."  label="fairvalue">
          <div>
          {`Option Fair Value Estimates (% of Price) as of ${modelDate}`}
          </div>
        </Header>
      );
    default:
      return null;
  }
};

export const onRenderTabSet = (tabSetNode, refs) => {
  const typeNode = tabSetNode.getType();
  if (typeNode === "tabset") {
    const children = tabSetNode.getChildren();
    children.forEach((child) => {
      const c = child;
      const comp = c.getComponent();
      const rect = c.getRect();
      if (comp) {
        refs.componentSize.current[comp] = {
          width: rect.width,
          height: rect.height,
        };
      }
    });
  }
};
const getParentTabsets = (model) => {
  const tree = {};
  const walk = (obj) => {
    if (obj.children) {
      const parent = obj.id;
      tree[parent] = [];
      obj.children.forEach((item) => {
        tree[parent].push(item.id);
        walk(item);
      });
    }
  };
  walk(model.layout);
  const parents = {};
  Object.entries(tree).forEach((item) => {
    item[1].forEach((child) => {
      parents[child] = item[0];
    });
  });
  return parents;
};

const modifyModel = (model, layoutState, setLayoutState) => {
  if (layoutState.actionRef.current !== undefined) {
    let tabsetId = "";
    if (layoutState.actionRef.current.isTab) {
      const parent = getParentTabsets(model);
      tabsetId = parent[layoutState.actionRef.current.tabid];
    } else {
      tabsetId = layoutState.actionRef.current.tabid;
    }
    let update = (obj) => {
      if (obj.id === tabsetId) {
        //update
        Object.entries(layoutState.actionRef.current.attributes).forEach(
          (item) => {
            obj[item[0]] = item[1];
          }
        );
      } else if (obj.children) {
        obj.children.forEach((item) => update(item));
      }
    };
    update(model.layout);

    const newState = {
      ...layoutState,
      model: Model.fromJson(model),
    };

    setLayoutState(newState);
    return model;
  } else {
    return model;
  }
};

export const onAction = (action, layoutState) => {
  const nodeID = action.data.fromNode;
  if (nodeID) {
    layoutState.actions.prepareAction(nodeID);
  }
  return action;
};

export const layoutModelChange = (
  model,
  layoutState,
  setLayoutState,
  grefs
) => {
  // console.log(JSON.stringify(model.toJson()));
  grefs.layout.current = JSON.stringify(
    modifyModel(model.toJson(), layoutState, setLayoutState)
  );
};
